<div
  class="mv6 flex"
  [id]="contentId"
  [style.background-color]="backgroundColor"
  [ngStyle]="{'background-color': contentType === 'booker' ? 'transparent': backgroundColor}"
></div>
